import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getReservedForFieldValues as getReservedForFieldValuesAPI} from '../../../services/entities/entities_v2'
import fixture from '../../../fixtures/reservations/reservedForFieldValues.json'

export async function getReservedForFieldValues(dispatch, fieldIds, fieldType, search = '') {
  try {
    dispatch({type: PENDING})
    let response = await getReservedForFieldValuesAPI(fieldIds, fieldType, search)
    //let response = fixture
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${fieldIds}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
